/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCheckouts200ResponseAllOfData } from './GetCheckouts200ResponseAllOfData';
import {
    GetCheckouts200ResponseAllOfDataFromJSON,
    GetCheckouts200ResponseAllOfDataFromJSONTyped,
    GetCheckouts200ResponseAllOfDataToJSON,
} from './GetCheckouts200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCheckouts200ResponseAllOf
 */
export interface GetCheckouts200ResponseAllOf {
    /**
     * 
     * @type {GetCheckouts200ResponseAllOfData}
     * @memberof GetCheckouts200ResponseAllOf
     */
    data: GetCheckouts200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetCheckouts200ResponseAllOf interface.
 */
export function instanceOfGetCheckouts200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetCheckouts200ResponseAllOfFromJSON(json: any): GetCheckouts200ResponseAllOf {
    return GetCheckouts200ResponseAllOfFromJSONTyped(json, false);
}

export function GetCheckouts200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCheckouts200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCheckouts200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetCheckouts200ResponseAllOfToJSON(value?: GetCheckouts200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCheckouts200ResponseAllOfDataToJSON(value.data),
    };
}

